<div
	[@fadeInOut]
	id="default-modal"
	tabindex="-1"
	aria-hidden="true"
	class="transition-all overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[100%] max-h-full flex inset-0 bg-gray-600 bg-opacity-50"
>
	<div class="relative p-4 w-full max-w-2xl max-h-full" style="max-width: 450px">
		<!-- Modal content -->
		<div class="relative bg-white rounded-lg shadow">
			<!-- Modal header -->
			<div class="flex items-center justify-between p-4">
				<button
					(click)="closeModal()"
					type="button"
					class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
					data-modal-hide="default-modal"
					style="position: absolute; right: 15px; top: 15px"
				>
					<svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
						<path
							stroke="currentColor"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
						/>
					</svg>
					<span class="sr-only">Close modal</span>
				</button>
			</div>
			<!-- <h3 class="font-lato text-f20 text-center font-semibold text-black">Términos y Condiciones</h3> -->
			<!-- Modal body -->
			<div class="pl-4 pr-4 md:pl-5 md:pr-5 space-y-4">
				<div class="flex">
					<div class="pr-4">
						<p class="font-normal text-[#000] font-lato text-f16 leading-[120%]">{{ payload?.data?.horaEmbarque }}</p>
					</div>
					<div class="flex flex-wrap">
						<div style="width: 19px; margin-top: 4px">
							<div>
								<img src="images/icon-origen.png" />
							</div>
							<div style="height: calc(100% - 19px)">
								<div style="width: 3px; background: #ec6726; height: 100%; margin: auto"></div>
								<!-- <img
									[src]="escalas.length ? 'images/escalas-inicio.png' : 'images/direccion-vertical.png'"
									style="margin: auto"
								/> -->
							</div>
						</div>
						<div class="mb-4 pl-4" style="width: calc(100% - 19px)">
							<p class="font-normal text-[#000] font-lato text-f16 leading-[120%]">Embarque:</p>
							<p class="font-black text-[#000] font-lato text-f20 leading-[120%]">
								{{ payload?.data?.origenFormateado }}
							</p>
							<p class="font-normal text-[#000] font-lato text-f15 leading-[140%]">
								{{ payload?.data?.direccionEmbarque }}
							</p>
							<p class="font-normal text-[#959595] font-lato text-f15 leading-[160%]">{{ fechaFormateadaIda }}</p>
						</div>
					</div>
				</div>
				@if (escalas.length > 0) {
				<div style="margin-top: -4px !important" class="flex">
					<div class="pr-4" style="width: 57px"></div>
					<div class="block w-full">
						<div class="block" id="collald">
							<div class="w-full max-w-xl">
								<button
									type="button"
									(click)="open = !open; onToggle()"
									class="flex w-full items-center justify-between sddsdsdsd"
									style="padding: 0 1px"
									[attr.aria-expanded]="open"
								>
									<div
										class="flex justify-center items-center"
										style="
											height: 28px;
											width: 28px;
											border-radius: 50%;
											background-color: #fff;
											font-size: 12pt;
											color: #000;
											border: #ec6726 2px solid;
											font-weight: 500;
										"
									>
										@if(open){
										<svg
											class="h-6 w-6 transition-transform"
											[class.rotate-180]="open"
											viewBox="0 0 20 20"
											fill="currentColor"
										>
											<path
												d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.94l3.71-3.71a.75.75 0 1 1 1.06 1.06l-4.24 4.24a.75.75 0 0 1-1.06 0L5.21 8.29a.75.75 0 0 1 .02-1.08z"
											/>
										</svg>
										}@else{
										<p>+{{escalas.length}}</p>
										}
									</div>
									<!-- <div class="flex justify-center items-center">
										
										
									</div> -->
									<div class="ksksks">
										<h3 style="font-size: 11.5pt" class="font-lato">Ver detalle escalas</h3>
									</div>

									<!-- <span class="font-medium">Título del colapse</span> -->
									<svg
										class="h-6 w-6 transition-transform"
										[class.rotate-180]="open"
										viewBox="0 0 20 20"
										fill="currentColor"
									>
										<path
											d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.94l3.71-3.71a.75.75 0 1 1 1.06 1.06l-4.24 4.24a.75.75 0 0 1-1.06 0L5.21 8.29a.75.75 0 0 1 .02-1.08z"
										/>
									</svg>
								</button>

								<div
									#panel
									class="overflow-hidden transition-[max-height] duration-300 ease-in-out"
									[style.maxHeight.px]="panelMaxHeight"
								>
									<div class="py-3 text-sm text-gray-600" style="padding: 0 5.5px">
										<div
											style="margin-top: -4px !important"
											class="flex"
											[class.items-center]="first"
											*ngFor="let item of escalas; let first = first; let last = last"
										>
											<div style="width: 19px; margin-top: 4px">
												<div>
													@if(first){
													<div style="width: 3px; background: #ec6726; height: 30px; margin: auto"></div>
													}
													<img
														width="25"
														height="25"
														src="https://img.icons8.com/ios/50/place-marker--v1.png"
														alt="place-marker--v1"
													/>
												</div>
												<div style="height: 30px">
													<div style="width: 3px; background: #ec6726; height: 100%; margin: auto"></div>
													@if(!last){ }
												</div>
											</div>
											<div class="mb-4 pl-4" style="width: calc(100% - 19px)">
												<p
													class="font-normal text-[#000] font-lato text-f13 leading-[120%]"
													[ngStyle]="{ 'margin-top': first ? '25px' : '9px' }"
												>
													{{ item }}
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				}

				<div class="flex relative" style="padding-top: 20px">
					<div class="pr-4">
						<p class="font-normal text-[#000] font-lato text-f16 leading-[120%]">
							{{ payload?.data?.horaDesembarque }}
						</p>
					</div>
					<div class="flex flex-wrap">
						<div style="width: 1px; margin-top: 4px">
							<div class="text-center">
								<div
									[ngStyle]="{
										top: '-17px',
										width: (escalas.length > 0 ? '18px' : '19px')
									}"
									class="absolute"
								>
									<div style="width: 3px; background: #ec6726; height: 30px; margin: auto"></div>
									<div class="arrow____"></div>
								</div>

								<img class="m-auto" src="images/llegada-icon.png" />
							</div>
						</div>
						<div class="mb-4 pl-4" style="width: calc(100% - 19px)">
							<p class="font-normal text-[#000] font-lato text-f16 leading-[120%]">Destino:</p>
							<p class="font-black text-[#000] font-lato text-f20 leading-[120%]">
								{{ payload?.data?.destinoFormateado }}
							</p>
							<p class="font-normal text-[#000] font-lato text-f15 leading-[140%]">
								{{ payload?.data?.direccionDesembarque }}
							</p>
							<p class="font-normal text-[#959595] font-lato text-f15 leading-[160%]">{{ fechaFormateadaVuelta }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
